import { createContext } from 'react';

export const initialState = null;
const ToastContext = createContext(initialState);

export default ToastContext;
